
export default function clearAnnouncements() {
    const announcementEls = Array.from(
        document.querySelectorAll(
            "status,[role=status],[aria-live=polite],[aria-live=assertive]"
        )
    );
    announcementEls.forEach((el) => (el.innerHTML = ""));
}
